import i18n from '../../../../i18n'

import { TemplateConfirmationInsertReplaceOptionValue } from './TemplateConfirmationModal.enums'

export function isTemplateConfirmationInsertReplaceOptionValueInsert(value) {
  return value === TemplateConfirmationInsertReplaceOptionValue.Insert
}

export function getOptions() {
  return [
    {
      id: TemplateConfirmationInsertReplaceOptionValue.Replace,
      label: i18n.t(
        'Newsboard.ConfirmationModalReplaceTemplateeOptionValueOptionKey'
      ),
    },
    {
      id: TemplateConfirmationInsertReplaceOptionValue.Insert,
      label: i18n.t(
        'Newsboard.ConfirmationModalInsertTemplateOptionValueOptionKey'
      ),
    },
  ]
}
